var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 24,
    viewBox: "0 0 47 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2486_68166)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93461e-06 4.28571C0.408063 1.19999 10.2598 3.14285 10.2598 3.14285L11.2508 6.05713L18.2461 7.08571C19.1788 5.65713 20.1698 4.45713 21.2774 3.71428C25.6495 0.97142 33.0529 5.94285 33.0529 5.94285C33.0529 5.94285 25.4163 -2.00001 30.9543 0.514277C48.4426 9.31428 41.4473 10.8 41.4473 10.8H36.5506L37.3084 12.0571C38.0662 11.7143 38.9406 11.5428 39.8733 11.5428C43.371 11.5428 46.2274 14.3428 46.2274 17.8286C46.2274 21.3143 43.371 24.0571 39.8733 24.0571C36.3757 24.0571 33.5193 21.2571 33.5193 17.8286C33.5193 15.8857 34.3937 14.1714 35.851 13.0286L35.1515 11.9428L32.4117 19.3714H13.8741C13.1745 22.0571 10.6679 24.0571 7.69486 24.0571C4.1972 24.0571 1.28248 21.2571 1.28248 17.8286C1.28248 14.4 4.1389 11.6 7.63656 11.6C10.8428 11.6 13.5243 13.9429 13.9324 16.9714H13.9906C13.9906 16.9714 14.5736 14.9714 15.5646 12.4571C12.3001 11.3143 -0.349763 6.97142 2.93461e-06 4.28571ZM39.8733 21.6571C42.0885 21.6571 43.8956 19.8857 43.8956 17.7143C43.8956 15.5428 42.0885 13.7714 39.8733 13.7714C39.407 13.7714 38.9989 13.8286 38.5909 14L40.6312 17.2571L39.1155 18.1714L37.0752 14.9143C36.3174 15.6 35.851 16.6286 35.851 17.7143C35.851 19.8857 37.6582 21.6571 39.8733 21.6571V21.6571ZM31.887 18.2857L34.2188 11.3143L33.2861 11.0286L30.9543 18L31.887 18.2857ZM7.69486 13.8286C5.47967 13.8286 3.67255 15.6 3.67255 17.7714C3.67255 19.9428 5.47967 21.7143 7.69486 21.7143C9.3271 21.7143 10.7845 20.7429 11.3674 19.3143H6.47068V16.9143H11.5423C11.1342 15.1429 9.56028 13.8286 7.63656 13.8286H7.69486Z",
    fill: "#303030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2486_68166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46.2857,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgA);
export default __webpack_public_path__ + "static/media/A.c37d22afa147f7158622db998fb0037d.svg";
export { ForwardRef as ReactComponent };